import { UserOutputDTO } from "@kalyzee/kast-web-sdk/http";
import { useEffect, useState } from "react";
import { toastError } from "../../helpers/toast";
import { useAppSelector, useRequestAppDispatch } from "../../hooks/app";
import { AuthStatus } from "../../interfaces/session";
import { requestGetMe } from "../request/actions";
import { selectAuthStatus, selectCompatibilityInfos, selectDisableGoogleLogin, selectMicrophone, selectMode, selectScreen, selectUser } from "./selectors";
import { setUser } from "./slices";

export const useAuthStatus = (): AuthStatus => useAppSelector(selectAuthStatus);
export const useScreen = () => useAppSelector(selectScreen);
export const useMode = () => useAppSelector(selectMode);
export const useUser = () => useAppSelector(selectUser);
export const useDisableGoogleLogin = () => useAppSelector(selectDisableGoogleLogin);
export const useCompatibilityInfos = () => useAppSelector(selectCompatibilityInfos);
export const useMicrophone = () => useAppSelector(selectMicrophone);

export const useUserSession = () => {
  const requestDispatch = useRequestAppDispatch();

  const authStatus = useAuthStatus();
  const user = useUser();
  const mode = useMode();

  const [userFetchStatus, setUserFetchStatus] = useState<"connecting" | "connected" | "disconnected">("disconnected");

  const getMe = async () => {
    setUserFetchStatus("connecting");
    try {
      const response = await requestDispatch<UserOutputDTO>(requestGetMe());
      setUserFetchStatus("connected");
      setUser(response.data);
    } catch (error) {
      console.error(`[ERROR] requestGetMe: `, error);
      toastError(`Une erreur est apparue.`);
      setUserFetchStatus("disconnected");
    }
  };

  useEffect(() => {
    if (authStatus === AuthStatus.In) getMe();
  }, [authStatus]);

  return {
    user,
    mode,
    authStatus,
    userFetchStatus,
    retry: getMe,
  };
};
